// src/components/LocationSection.js
import React from "react";

import { ArrowIcon } from "./Icons";

// Pin by coordinates (taken from the Google Maps listing below). Searching the
// street address dropped the pin on a neighbouring business in the same block.
const OFFICE_COORDS = "-36.9646867,174.9036135";

const MAP_EMBED_SRC = `https://maps.google.com/maps?q=${OFFICE_COORDS}&z=17&t=m&output=embed`;

const MAP_LINK =
  "https://www.google.com/maps/place/Expert+Finance/@-36.9646867,174.9010332,17z/data=!4m8!3m7!1s0x6d0d4d165155d12f:0x9e4121e5b2e5ff7e!8m2!3d-36.9646867!4d174.9036135!9m1!1b1!16s%2Fg%2F11jzvn2rkp?entry=ttu&g_ep=EgoyMDI1MTEyMy4xIKXMDSoASAFQAw%3D%3D";

const DIRECTIONS_LINK = `https://www.google.com/maps/dir/?api=1&destination=${OFFICE_COORDS}`;

const ICON = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

const POINTS = [
  {
    text: "Easy access from East & South Auckland",
    icon: (
      <svg {...ICON}>
        <path d="M3 11l18-8-8 18-2-8z" />
      </svg>
    ),
  },
  {
    text: "Parking options nearby",
    icon: (
      <svg {...ICON}>
        <rect x="4" y="3.5" width="16" height="17" rx="3" />
        <path d="M10 16.5v-9h3a2.75 2.75 0 0 1 0 5.5h-3" />
      </svg>
    ),
  },
  {
    text: "Online video appointments also available",
    icon: (
      <svg {...ICON}>
        <rect x="3" y="6" width="13" height="12" rx="2.5" />
        <path d="M16 10.5l5-3v9l-5-3" />
      </svg>
    ),
  },
];

function LocationSection() {
  return (
    <section className="location-section">
      <div className="location-head">
        <span className="location-kicker">Visit us</span>
        <h2 className="location-title">
          Where to find us.
        </h2>
        <p className="location-subtitle">
          The office is in Flat Bush, with parking close by. If getting across
          town is a hassle, we are just as happy to do it online.
        </p>
      </div>

      <div className="location-panel">
        <div className="location-info">
          <div className="location-address-block">
            <span className="location-pin" aria-hidden="true">
              <svg {...ICON}>
                <path d="M12 21s-7-6.1-7-11.5a7 7 0 0 1 14 0C19 14.9 12 21 12 21z" />
                <circle cx="12" cy="9.5" r="2.5" />
              </svg>
            </span>
            <div>
              <h3 className="location-name">Expert Finance</h3>
              <p className="location-address">
                Suite E3, 123 Ormiston Road
                <br />
                Flat Bush, Auckland 2019
                <br />
                New Zealand
              </p>
            </div>
          </div>

          <p className="location-note">
            Meetings are by appointment. Tell us when suits and how you would
            rather meet, and we will confirm a time.
          </p>

          <ul className="location-points">
            {POINTS.map(({ text, icon }) => (
              <li key={text}>
                <span className="location-point-icon">{icon}</span>
                {text}
              </li>
            ))}
          </ul>

          <div className="location-actions">
            <a
              href={DIRECTIONS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="pill-btn pill-btn-primary"
            >
              Get directions
              <ArrowIcon />
            </a>
            <a
              href={MAP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="location-link"
            >
              Open in Google Maps
            </a>
          </div>
        </div>

        <div className="location-map">
          <iframe
            src={MAP_EMBED_SRC}
            title="Expert Finance office location"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}

export default LocationSection;
